<template>
    <div v-if="searchParams">
        <progress-header />

        <div class="container mt-4">
            <div class="row">
                <div class="col-12 col-lg-9 mb-2">
                    <div class="card shadow-sm" v-if="!isLoggedIn">
                        <div class="row align-items-center justify-content-between px-4 py-3">
                            <div class="col-12 col-md-9 text-blue-600 font-weight-bold">
                                {{ $t('taxi.pages.passengers.login_in_to_speed_up_process') }}
                            </div>

                            <div class="col-12 col-md-3 text-right">
                                <router-link :to="{ name: 'login.index', query: {redirectTo: '/business-taxi/passengers'} }" class="btn btn-sm btn-outline-primary">
                                    {{ $t('auth.login_header') }}
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <form @submit.prevent="handleSubmit">
                        <div class="card booking-form-card shadow-sm">
                            <div class="card-header">
                                {{ $t('taxi.pages.passengers.passengers_data') }}
                            </div>

                            <div class="px-4 py-3">
                                <div class="mb-4" v-if="idx < showPassengersNumber" v-for="(passenger, idx) in passengers" :key="idx">
                                    <passengers-passenger :passenger="passenger" :idx="idx"
                                        @update="onPassengerUpdated"
                                    />
                                </div>

                                <a href="#" v-if="showPassengersNumber < passengersNumber" @click.prevent="increaseShownPassengersNumber">
                                    {{ $t('taxi.pages.passengers.add_next_passenger_data') }}
                                </a>
                            </div>
                        </div>

                        <div class="my-4">
                            <button type="submit" class="btn btn-primary">
                                {{ $t('next') }}
                            </button>
                        </div>
                    </form>
                </div>

                <div class="col-12 col-lg-3">
                    <the-cart />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import PassengersPassenger from '@components/Taxi/PassengersPassenger';
    import TheCart from './components/Cart/TheCart';
    import ProgressHeader from './components/ProgressHeader';
    import toastr from 'toastr';
    import {trackGA} from '@utilities/tracking';

    export default {
        components: {
            PassengersPassenger,
            ProgressHeader,
            TheCart,
        },

        computed: {
            ...mapGetters({
                searchParams: 'businessTaxi/searchParameters',
                travel: 'businessTaxi/getTravel',
                passengers: 'businessTaxi/getPassengers',
                showPassengersNumber: 'businessTaxi/showPassengersNumber',
                isLoggedIn: 'user/isLoggedIn',
                passengersNumber: 'businessTaxi/passengersNumber',
            }),
        },

        created() {
            trackGA('checkout_progress', {
                checkout_step: 3,
                checkout_option: window.location.pathname,
            });

            if (!this.travel) {
                this.$router.push({name: 'business-taxi.vehicles'});
            }

            if ((!this.passengers || this.passengers.length === 0) && this.searchParams) {
                this.$store.dispatch('businessTaxi/setPassengers', this.createPassengers(this.passengersNumber ? this.passengersNumber : 1));
            }
        },

        methods: {
            handleSubmit() {
                if (this.validatePhone()) {
                    this.$router.push({name: 'business-taxi.addresses'});
                }
            },

            createPassengers(quantity = 1) {
                const passengers = [];

                for (let i = 1; i <= quantity; i++) {
                    passengers.push(
                        this.passengerModel()
                    );
                }

                return passengers;
            },

            onPassengerUpdated(idx, data) {
                const passengers = JSON.parse(JSON.stringify(this.passengers));

                passengers[idx] = data;

                this.$store.dispatch('businessTaxi/setPassengers', passengers);
            },

            passengerModel() {
                return {
                    first_name: null,
                    last_name: null,
                    phone: null,
                };
            },

            increaseShownPassengersNumber() {
                this.$store.dispatch('businessTaxi/increaseShownPassengersNumber');
            },

            validatePhone() {
                let valid = true;
                let length_invalid = false;
                let plus_invalid = false;

                for (let idx in this.passengers) {
                    let invalid_phone = false;

                    if (this.passengers[idx].phone && this.passengers[idx].phone.length < 11) {
                        valid = false;
                        invalid_phone = true;
                        length_invalid = true;
                    }

                    if (this.passengers[idx].phone && this.passengers[idx].phone[0] !== '+') {
                        valid = false;
                        invalid_phone = true;
                        plus_invalid = true;
                    }

                    this.$set(
                        this.passengers,
                        idx,
                        Object.assign({}, this.passengers[idx], {invalid_phone})
                    );
                }

                if (!valid) {
                    if (length_invalid) {
                        toastr.error(this.$t('airport_transfers.pages.phone_length_error'));
                    }

                    if (plus_invalid) {
                        toastr.error(this.$t('phone_has_to_start_with_plus'));
                    }
                }

                return valid;
            },
        },
    };
</script>
